
import hotBg from './assets/sun.jpg';
import hot2Bg from './assets/sun2.jpg';
import coldBg from './assets/cold.jpeg';
import Description from './components/Description';
import { useEffect,useState } from 'react';
import { getFormattedWeatherData } from './WeathrService';


function App() {
  const [city,setCity] = useState("visakhapatnam");
  const [weather,setWeather] = useState(null);
  const [unit,setUnits] = useState("metric")
  const [bg,setBg] = useState(hot2Bg);

  useEffect(() => {
    const fetchWeatherData = async () => {
    const data = await getFormattedWeatherData(city, unit)
    setWeather(data);

    const threshold = unit ==='metric' ? 20:60;
    if(data.temp <= threshold) setBg(coldBg);
    else setBg(hotBg);
    };

    fetchWeatherData();
  }, [unit,city])

  const handleUnitsClick = (e) => {
    const button = e.currentTarget;
    const currentUnit = button.innerText.slice(1);

    const isCelsius = currentUnit === "C";
    button.innerText = isCelsius ? "°F" : "°C"
    setUnits(isCelsius ? "metric" :"imperial");
  }

    const enterKeyPressed = (e) => {
      if(e.keyCode === 13) {
        setCity(e.currentTarget.value)
        e.currentTarget.blur()
      }
    }
  return (
    <div className="app" style={{backgroundImage: `url(${bg})`}}>
      <div className='overlay'>
        {
          weather && (
            <div className='container'>
            <div className='section section__inputs'>
              <input onKeyDown={enterKeyPressed} type="text" name='city' placeholder='Enter City...'/>
                <button onClick={(e) =>handleUnitsClick(e)}>°F</button>
            </div>
    
              <div className='section section__temperature'>
              <div className='icon'>
                <h2>{`${weather.name},${weather.country}`}</h2>
                <img src={weather.iconURL} alt='img missing😥'/>
                <h2>{weather.description}</h2>
              </div>
              <div className='temperature'>
                <h1>{`${weather.temp.toFixed()} °${unit ==='metric'? 'C': 'F'}`}</h1>
              </div>
              </div>
            {/*bottom description */}
            <Description weather={weather} unit={unit} />
           </div>
          )
        }
      </div>
    </div>
  );
}

export default App;
